// @ts-nocheck
// tslint:disable
/**
 * PalmApp Server Web API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { WorkerMessageActionDto } from './worker-message-action-dto';

// tslint:disable
import { APIModel, APIModelOptions, AttributeMapItem } from "../base";

export class WorkerMessageDetailDto extends APIModel {
    /**
    * MessageRead identifier
    */
    id: number;
    /**
    * Message identifier
    */
    messageId: number;
    /**
    * Message caption
    */
    caption: string;
    /**
    * Markdown content of message
    */
    markdownData: string;
    /**
    * Date of creation of message
    */
    created: string;
    /**
    * List of message actions. Can be empty.
    */
    actions: Array<WorkerMessageActionDto>;

    constructor(options?: APIModelOptions) {
        super(WorkerMessageDetailDto.attributeTypeMap, options);
    }

    static get attributeTypeMap(): Array<AttributeMapItem> {
        return [
            { name: "id", type: "number" },
            { name: "messageId", type: "number" },
            { name: "caption", type: "string" },
            { name: "markdownData", type: "string" },
            { name: "created", type: "string" },
            { name: "actions", type: "Array<WorkerMessageActionDto>" }
        ];
    }
}




